export enum TodoVerticalAlignment {
    Top = 'top',
    Center = 'center',
}
